import React from 'react';
import {
    getAreaBulletPointsText,
    getPriceBulletPointsText,
} from '../../../common/search/realestate';
import { RealestateAd, RealestateProjectAd } from '../../../types';
import { useSearchAdClasses } from '../SearchAdClasses';
import { useSearchAdContext } from '../SearchAdContext';

const classes = {
    mobile: {
        bullets: 'text-xs s-text-subtle',
        separator: 'hidden',
    },
    desktop: {
        separator: 'sm:inline',
    },
};

type RealestateBulletsProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
    isLettings?: boolean;
};

export function RealestateBullets(props: RealestateBulletsProps) {
    const { ad, className = '', isLettings } = props;

    const { mode } = useSearchAdContext();
    const c = useSearchAdClasses({
        mode,
        mobileClasses: classes.mobile,
        desktopClasses: classes.desktop,
    });

    const priceText = getPriceBulletPointsText(ad, isLettings);
    const areaText = getAreaBulletPointsText(ad);

    if (!(priceText || areaText)) {
        return null;
    }

    return (
        <div className={`${c.bullets} ${className}`}>
            {priceText && <span>{priceText}</span>}
            {priceText && areaText && <span className={c.separator}> ∙ </span>}
            {areaText && <span>{areaText}</span>}
        </div>
    );
}
